export const ACCOUNT_SETUP_REQUEST = "ACCOUNT_SETUP_REQUEST";
export const ACCOUNT_SETUP_SUCCESS = "ACCOUNT_SETUP_SUCCESS";
export const ACCOUNT_SETUP_FAILURE = "ACCOUNT_SETUP_FAILURE";
export const RESET_ACCOUNT_SETUP_STATE = "RESET_ACCOUNT_SETUP_STATE";

